module.exports = __webpack_public_path__ + "img/icon_exchange_5people.de48b7d4.png";